__webpack_require__.p = "/tokens-scale-badge/system-email-templates/";